<div class="preview-dialog">
    <div class="preview-header">
        <div class="preview-titles">
            <span class="preview-title">{{ fileName }}</span>
            <span class="preview-subtitle" *ngIf="fileDescription as description">{{ description }}</span>
        </div>
        <button class="preview-close" type="button" (click)="close()" [attr.aria-label]="'permit.create.resources.close' | translate">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="preview-body">
        <iframe [src]="sanitizedUrl" title="{{ fileName }}"></iframe>
    </div>
</div>
